<template>
  <div>
    <el-tabs v-model="tab">
      <el-tab-pane label="服务概况" name="ref1">
        <ServiceSummary />
      </el-tab-pane>
      <el-tab-pane label="时长概况" name="ref2">
        <DurationSummary />
      </el-tab-pane>
      <el-tab-pane label="变化趋势" name="ref3">
        <Trend />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ServiceSummary from "./ServiceSummary";
import DurationSummary from "./DurationSummary";
import Trend from "./Trend";

export default {
  components: {
    ServiceSummary,
    DurationSummary,
    Trend
  },
  props: {},
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  data() {
    return {
      tab: "ref1"
    };
  },
  methods: {}
};
</script>
<style lang="less" scoped></style>
